import { Component, inject } from '@angular/core';
import { FormGroup, FormGroupDirective, FormsModule, NgForm, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { ErrorStateMatcher } from "@angular/material/core";
import { FormControl } from "@angular/forms";
import { ResetPasswordService } from '../../services/reset-password.service';
import { MyErrorStateMatcher } from '../../shared/my-error-state-matcher.class';

import {
    MAT_DIALOG_DATA,
    MatDialog,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogRef,
    MatDialogTitle,
  } from '@angular/material/dialog';
import { ShowMessageComponent } from '../../modals/show-message/show-message.component';
import { Router } from '@angular/router';
import { MessagesService } from '../../services/messages.service';
import { CommonModule } from '@angular/common';
import { SocialMediaComponent } from '../../share/social-media/social-media.component';


@Component({
    selector: 'app-forget-password',
    standalone: true,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        MatInputModule,
        MatButtonModule,
        CommonModule,
        SocialMediaComponent
    ],
    templateUrl: './forget-password.component.html',
    styleUrl: './forget-password.component.scss'
})
export class ForgetPasswordComponent {

    public dialogRef?: MatDialogRef<ShowMessageComponent>;
    readonly dialog = inject(MatDialog);

    public resetForm: FormGroup = new FormGroup({
        email: new FormControl('', [Validators.required, Validators.email]),
    });

        matcher = new MyErrorStateMatcher();

    constructor(
        private resetPasswordService: ResetPasswordService,
        public router: Router,
        private messagesService: MessagesService
    ) {

    }

    onSubmit() {
        this.resetPasswordService.resetPassword(this.resetForm.value.email)
        .subscribe({
            next: (data: any) => {
                console.log(data);
                if (data.status === 'success') {
                    this.openDialog(data.message)
                }
            },
            error: (error: any) => {
                console.error(error);
            }
        });
    }


      openDialog(message: string) {
    
        this.messagesService.setMessage(message);
    
        this.dialogRef = this.dialog.open(ShowMessageComponent, {
            width: '500px',
        });
    
        this.dialogRef.afterClosed().subscribe(result => {

            console.log(`Dialog result: ${result}`);
            this.router.navigate(['/login']);
        });
    }

}
